<template>
  <div class="auth">
    <div class="auth-banner">
      <img
        class="auth-banner-image"
        src="../assets/images/auth-doctor-banner.jpeg"
        alt="Doutor banner"
      />
    </div>

    <div class="auth-form">
      <RouterLink to="/">
        <img
          class="auth-form-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </RouterLink>

      <div class="auth-form-container">
        <h2 class="auth-title auth-form-title">Crie sua conta</h2>
        <h6 class="auth-subtitle auth-form-subtitle">
          Crie agora uma conta para agendar e acompanhar as suas consultas
          online com segurança e muito mais.
        </h6>

        <RegisterForm />
      </div>

      <p class="auth-text auth-form-account">
        Já tenho conta!
        <a href="/login">Entrar</a>
      </p>

      <AuthFormSocials />
    </div>
  </div>
</template>

<script>
import RegisterForm from "../components/RegisterForm.vue";
import AuthFormSocials from "../components/AuthFormSocials.vue";

export default {
  name: "RegisterView",
  components: {
    RegisterForm,
    AuthFormSocials
  }
};
</script>

<style lang="scss" scoped>
.auth-form-logo {
  display: block;
  height: 40px;
  width: auto;
}
</style>
